export { default } from './About.component';
